<template>
  <v-app>
    <Toolbar title="Order Detail"/>
    <v-content>

      <v-card>
        <v-flex xs10 sm10 offset-sm1>
          <v-container fluid>

            <v-card-title class="title">Device Order Form ({{ getOrder.id || 'no reference' }}) for {{ groupName }}</v-card-title>
            <v-form>

              <v-layout row wrap>
                <v-flex xs4>
                  <v-btn color="warning" @click="$router.push('/orders/' + groupId)">Back to Orders</v-btn>
                </v-flex>
                <v-flex xs4>
                  <v-btn color="info" @click="saveOrderForm">Save this order</v-btn>
                </v-flex>
                <v-flex xs4>
                  <v-btn color="success" :disabled="!shipEnabled" @click="shipDialog = true">Send order to Shipping</v-btn>
                </v-flex>
              </v-layout>

              <v-card>
                <v-card-title>
                  <v-flex>
                    <OrderDetailBusinessName />
                    <OrderDetailDeviceType/>
                    <OrderDetailIndustry/>
                    <OrderDetailReference/>
                  </v-flex>
                </v-card-title>
              </v-card>

              <v-card-title class="title">Merchant Account</v-card-title>
              <v-card>
                <v-card-title>
                  <v-flex>
                    <OrderDetailMerchantId/>
                    <OrderDetailCardBrands/>
                    <OrderDetailCardFeatures/>
                    <OrderDetailCardLimits/>
                  </v-flex>
                </v-card-title>
              </v-card>

              <v-card-title class="title">Client Details</v-card-title>
              <v-card>
                <v-card-title>
                  <v-flex>
                    <OrderDetailContact/>
                  </v-flex>
                </v-card-title>
              </v-card>

              <v-card-title class="title">Receipt Details</v-card-title>
              <v-card>
                <v-card-title>
                  <v-flex>
                    <OrderDetailReceipt/>
                  </v-flex>
                </v-card-title>
              </v-card>

              <v-card-title class="title">Semi-Integration API</v-card-title>
              <v-card>
                <v-card-title>
                  <v-flex>
                    <OrderDetailApi/>
                  </v-flex>
                </v-card-title>
              </v-card>

            </v-form>

            <v-card-title class="title"></v-card-title>
            <v-layout row wrap>
              <v-flex xs5>
                <v-btn color="error" @click="deleteDialog = true">Delete this order</v-btn>
              </v-flex>
              <v-flex xs1>
              </v-flex>
              <v-flex xs5>
                <v-btn color="info" @click="saveOrderForm">Save this order</v-btn>
              </v-flex>
            </v-layout>

          </v-container>
        </v-flex>
      </v-card>

      <v-layout row justify-center>
        <v-dialog v-model="deleteDialog" persistent max-width="290">
          <v-card>
            <v-card-title class="headline">Delete this Order?</v-card-title>
            <v-card-text>Please confirm that you want to delete this order. This cannot be undone.</v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red darken-1" flat @click.native="proceed">Yes, delete</v-btn>
              <v-btn color="green darken-1" flat @click.native="deleteDialog = false">No, cancel</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>

      <v-layout row justify-center>
        <v-dialog v-model="shipDialog" persistent max-width="290">
          <v-card>
            <v-card-title class="headline">Send Order to Shipping?</v-card-title>
            <v-card-text>Please confirm that you want to transfer this order to be shipped.</v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red darken-1" flat @click.native="shipOrder">Yes, ship</v-btn>
              <v-btn color="green darken-1" flat @click.native="shipDialog = false">No, cancel</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>

    </v-content>
  </v-app>
</template>

<script>
import Toolbar from '../components/Toolbar'
import OrderDetailBusinessName from '../components/OrderDetailBusinessName'
import OrderDetailDeviceType from '../components/OrderDetailDeviceType'
import OrderDetailIndustry from '../components/OrderDetailIndustry'
import OrderDetailReference from '../components/OrderDetailReference'
import OrderDetailMerchantId from '../components/OrderDetailMerchantId'
import OrderDetailCardBrands from '../components/OrderDetailCardBrands'
import OrderDetailCardFeatures from '../components/OrderDetailCardFeatures'
import OrderDetailCardLimits from '../components/OrderDetailCardLimits'
import OrderDetailContact from '../components/OrderDetailContact'
import OrderDetailApi from '../components/OrderDetailApi'
import OrderDetailReceipt from '../components/OrderDetailReceipt'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'OrderDetail',
  components: { Toolbar, OrderDetailBusinessName, OrderDetailDeviceType, OrderDetailIndustry, OrderDetailReference, OrderDetailMerchantId, OrderDetailCardBrands, OrderDetailCardFeatures, OrderDetailCardLimits, OrderDetailContact, OrderDetailApi, OrderDetailReceipt },
  data () {
    return {
      deleteDialog: false,
      shipDialog: false
    }
  },
  computed: {
    ...mapGetters(['getOrder', 'getActiveOrderIsDeleted']),
    orderId: function () {
      return this.$route.params.order_id
    },
    groupId: function () {
      return this.$route.params.group_id
    },
    shipEnabled: {
      get () { return (this.present(this.getOrder.business) && this.present(this.getOrder.deviceType) && this.present(this.getOrder.contactName) && this.present(this.getOrder.shippingLine1) && this.present(this.getOrder.merchantId)) },
      set () { }
    },
    groupName: function () {
      let out = ''
      if (this.$store.state.groups[this.groupId] !== undefined) {
        out = 'for ' + this.$store.state.groups[this.groupId].name
      }
      return out
    }
  },
  watch: {
    getActiveOrderIsDeleted: function (val) {
      if (val === true) {
        this.$store.state.activeOrderIsDeleted = false
        this.backToGroup()
      }
    }
  },
  mounted () {
    if (this.orderId === undefined || this.orderId === 'undefined') {
      this.$router.push({path: '/groups'})
    }
    this.fetchAll()
    this.fetchOrder(this.orderId)
  },
  methods: {
    ...mapActions(['fetchOrder', 'fetchAll',  'prepareOrderId', 'saveOrderForm', 'shipOrderForm', 'deleteOrderForm']),
    present: function (val) {
      let output = true
      if (val === undefined) { output = false }
      if (val === '') { output = false }
      if (val === 'undefined') { output = false }
      if (val === null) { output = false }
      return output
    },
    pad: function (num, size) {
      let s = num + ''
      while (s.length < size) s = '0' + s
      return s
    },
    backToGroup: function () {
      this.$router.push('/orders/' + this.getOrder.group)
    },
    proceed: function () {
      this.deleteDialog = false
      this.deleteOrderForm(this.orderId)
    },
    shipOrder: function () {
      if (this.getOrder.merchantId !== '') {
        if (this.getOrder.deviceType.indexOf('barclays_') !== -1) {
          this.$store.commit('updateOrder', ['merchantId', this.pad(this.getOrder.merchantId, 7)])
        } else {
          this.$store.commit('updateOrder', ['merchantId', this.pad(this.getOrder.merchantId, 9)])
        }
      }
      this.shipDialog = false
      this.shipOrderForm()
      this.$store.commit('showSnack', 'Order sent for shipping.')
      this.backToGroup()
    }
  }
}
</script>

<style scoped>

</style>
